<div class="table-page dashboard-page">
  <header class="header">
    <div class="title-row">
      <button type="button" class="back" title="بازگشت" aria-label="بازگشت" (click)="goBack()">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <h1 class="title">داشبورد تخصصی</h1>
      <div class="actions">
        <button type="button" class="btn btn-ghost" id="filterToggle" [attr.aria-expanded]="filtersOpen"
          aria-controls="filtersWrap" (click)="filtersOpen = !filtersOpen">
          <i class="fa fa-sliders" aria-hidden="true"></i> فیلتر
          <i class="fa fa-chevron-down chev" aria-hidden="true"></i>
        </button>
        <span class="actions-sep" aria-hidden="true"></span>
        <button type="button" class="btn-round" title="راهنما" aria-label="راهنما" (click)="guid(39)">
          <i class="fa fa-question" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="collapsible" id="filtersWrap" [class.collapsed]="!filtersOpen">
      <div class="collapsible-inner">
        <div class="filters">
          <div class="field" [formGroup]="dataFrom">
            <label class="field-label" for="startDate">از تاریخ</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateFormat]="'jYYYY/jMM/jDD'">
              <input id="startDate" type="text" formControlName="date" class="control num" readonly />
            </ng-persian-datepicker>
          </div>
          <div class="field" [formGroup]="dataTo">
            <label class="field-label" for="endDate">تا تاریخ</label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
              [dateFormat]="'jYYYY/jMM/jDD'">
              <input id="endDate" type="text" formControlName="date" class="control num" readonly />
            </ng-persian-datepicker>
          </div>
          <label class="field" for="domainDashbord">
            <span class="field-label">حوزه خدمت</span>
            <select class="control" id="domainDashbord">
              <option value="-1">انتخاب کنید</option>
              <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
            </select>
          </label>
          <div class="field">
            <label class="field-label" for="Stime">از ساعت</label>
            <div class="clockpicker">
              <input type="text" class="control num" id="Stime" readonly [formControl]="strSTime" />
            </div>
          </div>
          <div class="field">
            <label class="field-label" for="Etime">تا ساعت</label>
            <div class="clockpicker">
              <input type="text" class="control num" id="Etime" readonly [formControl]="strETime" />
            </div>
          </div>
          <label class="field" for="carGroup">
            <span class="field-label">نوع خودرو</span>
            <select id="carGroup" class="control">
              <option value="-1">نمایش همه</option>
              <option *ngFor="let item of groupCar" value="{{item.tiMobileType}}">{{item.strComment}}</option>
            </select>
          </label>
          <div class="filter-actions">
            <button type="button" class="btn btn-primary" (click)="search()">
              <i class="fa fa-search" aria-hidden="true"></i> به روز رسانی
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>

<div class="dashboard-grid">
    <div id="chart6" class="card dashboard-chart dashboard-chart--wide">
        <div class="">
            <app-chart [context]="totalMileageChart"></app-chart>
        </div>
    </div>

    <div id="chart17" class="card dashboard-chart dashboard-chart--wide">
        <div class="">
            <app-chart [context]="entryExitMileageChart"></app-chart>
        </div>
    </div>

    <div id="chart4" class="card dashboard-chart dashboard-chart--wide">
        <div class="">
            <app-chart [context]="dailyWorkingHoursChart"></app-chart>
        </div>
    </div>

    <div id="chart2" class="card dashboard-chart dashboard-chart--wide">
        <div class="">
            <app-chart [context]="dailyMileageChart"></app-chart>
        </div>
    </div>

    <div id="chart7" class="card dashboard-chart dashboard-chart--wide">
        <div class="dirI">
            <app-chart [context]="repairCostChart" (itemClick)="onRepairCostClick($event)"></app-chart>
        </div>
    </div>

    <div id="chart5" class="card dashboard-chart dashboard-chart--wide">
        <div class="">
            <app-chart [context]="todayMileageChart"></app-chart>
        </div>
    </div>

    <div id="chart8" class="card dashboard-chart dashboard-chart--wide">
        <div class="dirI">
            <app-chart [context]="mostExpensiveVehiclesChart"></app-chart>
        </div>
    </div>

    <div id="chart16" class="card dashboard-chart dashboard-chart--wide">
        <div class="dirI">
            <app-chart [context]="fuelConsumptionChart"></app-chart>
        </div>
    </div>

    <div id="chart9" class="card dashboard-chart dashboard-chart--wide">
        <div class="dirI">
            <app-chart [context]="serviceDueChart" (itemClick)="onServiceDueClick($event)"></app-chart>
        </div>
    </div>
    <div class="card dashboard-chart dashboard-chart--wide">
        <div class="dirI">
            <h2 class="dashboard-card-title">وسایل نقلیه ای که بیش از یک هفته حرکت نداشته اند</h2>
            <div class="table-scroll" *ngIf="tabelArray[0]">
            <table>
                <thead>
                    <tr>
                        <th scope="col">وسیله نقلیه</th>
                        <th scope="col">وسیله نقلیه</th>
                        <th scope="col">وسیله نقلیه</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of tabelArray ;let i=index">
                        <td class="pointer text-primary" *ngFor="let items of tabelArray[i]" (click)="showModal(items)">
                            {{items.strFullName}}</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <p class="muted" *ngIf="!tabelArray[0]">اطلاعاتی برای نمایش وجود ندارد.</p>
        </div>
    </div>


    <div class="card dashboard-chart dashboard-chart--wide">
        <div class="dashboard-map-heading">
            <h2 class="dashboard-card-title">وضعیت پراکندگی تخلفات </h2>
        </div>
        <div class="dashboard-map-filter">
            <div class="field">
                <select class="control" aria-label="نوع تخلف" (change)="journalTypeChange($event.target)">
                    <option *ngFor="let item of JournalTypeData" value="{{item.tiJournalType}}">{{item.strComment}}
                    </option>
                </select>
            </div>
        </div>
        <div class="dashboard-map">

            <div id="test2" class="fixed-mapCluster">
                <div class="position-absolute" id="map_tooltips" data-bs-html="true">
                </div>
            </div>
        </div>
    </div>

    <div class="card dashboard-chart dashboard-chart--wide">
        <div class="dashboard-map-heading">
            <h2 class="dashboard-card-title"> نقشه پراکندگی محل سوختگیری</h2>
        </div>
        <div class="dashboard-map">
            <div id="map" class="fixed-mapCluster">
                <div class="position-absolute" id="map_tooltip" data-bs-html="true">
                </div>
            </div>
        </div>
    </div>

    <div class="card dashboard-chart dashboard-chart--wide">
        <div class="dashboard-map-heading">
            <h2 class="dashboard-card-title">وضعیت پراکندگی خودروها</h2>
        </div>
        <div class="dashboard-map">

            <div id="test" class="fixed-mapCluster">
                <div class="position-absolute" id="map_tooltip" data-bs-html="true">
                </div>
            </div>
        </div>
    </div>





  </div>
</div>

<!-- Modal -->
<div class="modal fade dirI" id="carModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" *ngIf="modalData">{{modalData.strFullName}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p *ngIf="modalData">حوزه خدمت : {{modalData.strMobileDomain_strComment }}</p>
                <p *ngIf="modalData">پلاک : {{modalData.strVehicleNo }}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>

            </div>
        </div>
    </div>
</div>

<!--Car Status Modal-->
<div class="modal fade dirI" id="CarStatusModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" style="max-height:60vh;overflow: auto;">
                <div class="table-responsive dirI rounded-3 border border-2 my-2">
                    <table class="table table-striped " id="car-status-exel">
                        <thead>
                            <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                            <tr class="">
                                <th>#</th>
                                <th>نام و نام خانوادگی </th>
                                <th>شماره موبایل راننده </th>
                                <th>پلاک </th>
                                <th>حوزه خدمت </th>
                                <th>گروه </th>
                                <th>نوع </th>
                                <th>سال ساخت</th>
                                <th class="d-none">UnitID </th>
                                <th class="d-none">کیلومتر فعلی </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="" *ngFor="let item of carStatusData;let i=index">
                                <td>{{i+1|faNum}}</td>
                                <td>{{item.strFullName}}</td>
                                <td>{{item.strCellNo}}</td>
                                <td>{{item.strVehicleNo}}</td>
                                <td>{{item.strMobileDomain_strComment}}</td>
                                <td>{{item.strMobileGroup_strComment}}</td>
                                <td>{{item.strMobileType_strComment}}</td>
                                <td>{{item.iYearConstruction}}</td>
                                <td class="d-none">{{item.strUnitID }}</td>
                                <td class="d-none">{{item.fLastKM }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="exportexcel('car-status-exel')">خروجی
                    اکسل</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade dirI" id="carCluster" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" *ngIf="clusterModal">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{clusterModal.strFullName}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap">
                <div class="col-5" *ngIf="clusterModal.strDate">
                    <p class="text-secondary dirI"> <span class="bold">آخرین زمان موقعیت</span> :
                        {{clusterModal.strDate}}-{{clusterModal.strTime}}
                    </p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strMobile">
                    <p class="text-secondary"> <span class="bold">موبایل</span> : {{clusterModal.strMobile}}</p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strMobileType_strComment">
                    <p class="text-secondary"> <span class="bold">گروه خودرو</span> :
                        {{clusterModal.strMobileType_strComment}}
                    </p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strVehicleNo">
                    <p class="text-secondary"><span class="bold">پلاک</span> : {{clusterModal.strVehicleNo}}</p>
                </div>
                <div class="col-5 " *ngIf="clusterModal.strJournalType_strComment">
                    <p class="text-secondary"><span class="bold">تخلف</span> :
                        {{clusterModal.strJournalType_strComment}}</p>
                </div>
                <div class="col-5" *ngIf="clusterModal.tiMaxSpeed">
                    <p class="text-secondary"><span class="bold">حداکثر سرعت مجاز</span> : {{clusterModal.tiMaxSpeed}}
                    </p>
                </div>
                <div class="col-5" *ngIf="clusterModal.strComment">
                    <p class="text-secondary"><span class="bold">توضیحات</span> : {{clusterModal.strComment}}</p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
            </div>
        </div>
    </div>
</div>
